import { MenuItem } from "@headlessui/react";
import { PencilSquareIcon, TrashIcon, UserIcon } from "@heroicons/react/24/solid";
import { twMerge } from "tailwind-merge";

type MenuItemIcons = "Pencil" | "User" | "Trash";

type RepresentativeTableItemMenuItemProps = {
  title: string;
  icon: MenuItemIcons;
  action: () => void;
  showBorderBottom?: boolean;
  dataCy?: string;
};

export const MenuItemWithIcon = (props: RepresentativeTableItemMenuItemProps) => {
  const { title, icon, action, showBorderBottom, dataCy } = props;

  const getIcon = (icon: MenuItemIcons) => {
    switch (icon) {
      case "Pencil":
        return <PencilSquareIcon className="h-5 w-5" />;
      case "User":
        return <UserIcon className="h-5 w-5" />;
      case "Trash":
        return <TrashIcon className="h-5 w-5" />;
    }
  };

  return (
    <MenuItem>
      <div
        onClick={action}
        className={twMerge(
          "flex px-4 py-2 text-slate-600 text-sm hover:bg-slate-50",
          showBorderBottom && "border-b"
        )}
      >
        {getIcon(icon)}
        <a data-cy={dataCy} href="#" className="ml-2 font-semibold">
          {title}
        </a>
      </div>
    </MenuItem>
  );
};
